// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__V8Lu+","content":"Footer_content__rw0cu","nav":"Footer_nav__JkC9t","nav-item":"Footer_nav-item__9gZ0r"};